import {IxApi} from 'vue-src/IxPlugin/api'
import IxModel from 'vue-src/classes/_ix-model'

const AddressSchema = {
  'required': ['address_type', 'name', 'address1', 'city', 'state', 'postal_code'],
  'properties': {
    'url': {
      'type': 'string',
      'read_only': true,
      'label': 'Url'
    },
    'nickname': {
      'type': 'string',
      'read_only': false,
      'label': 'Nickname',
      'maxLength': 64
    },
    'address_type': {
      'type': 'string',
      'read_only': false,
      'label': 'Address type',
      'enum': ['shipto', 'billto', 'customer',]
    },
    'name': {
      'type': 'string',
      'read_only': false,
      'label': 'Name',
      'minLength': 1,
      'maxLength': 30
    },
    'contact_name': {
      'type': 'string',
      'read_only': false,
      'label': 'Contact Name',
      'minLength': 1,
      'maxLength': 30
    },
    'address1': {
      'type': 'string',
      'read_only': false,
      'label': 'Address1',
      'minLength': 1,
      'maxLength': 30
    },
    'address2': {
      'type': 'string',
      'read_only': false,
      'label': 'Address2',
      'maxLength': 30
    },
    'address3': {
      'type': 'string',
      'read_only': false,
      'label': 'Address3',
      'maxLength': 30
    },
    'city': {
      'type': 'string',
      'read_only': false,
      'label': 'City',
      'minLength': 1,
      'maxLength': 20
    },
    'state': {
      'type': 'string',
      'read_only': false,
      'label': 'State',
      'minLength': 1,
      'maxLength': 2
    },
    'postal_code': {
      'type': 'string',
      'read_only': false,
      'label': 'Postal code',
      'minLength': 1,
      'maxLength': 10
    },
    'country': {
      'type': 'string',
      'read_only': false,
      'label': 'Country',
      'maxLength': 2
    },
    'default': {
      'type': 'boolean',
    }
  }
}


class IxAddress extends IxModel{
  defaults(){
    return {
      address_type: 'customer',
      name: '',
      contact_name: '',
      address1: '',
      address2: '',
      address3: '',
      city: '',
      state: '',
      postal_code: '',
      country: 'US',
      nickname: '',
      url: '',
      default:false,
    }
  }

  address(){
    return IxApi.addresses
  }

  schema(){
    return AddressSchema
  }

  validator(){
    return this.$ajv().compile(this.schema())
  }

}

export default IxAddress



// WEBPACK FOOTER //
// ./ixcms/themes/gunoldusa/src/vue-src/classes/ix-address.js